/* eslint-disable react/prefer-stateless-function */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import CanvasFlow from '../../components/CanvasFlow/CanvasFlow';
import { addNodeFlow, createEdge, createNode } from '../../components/CanvasFlow/Helpers';
import ComponentsType, { findComponentBy } from '../../components/Component/ComponentType';
import ConfigurationsBox from '../../components/ConfigurationsBox/ConfigurationsBox';
import DeleteConfirmation from '../../components/DeleteConfirmation/DeleteConfirmation';
import DialogNotification from '../../components/DialogNotification/DialogNotification';
import Loading from '../../components/Loading/Loading';
import MessageNotification from '../../components/MessageNotification/MessageNotification';
import ContextBots from '../../context/FlowContext';
import ContextSaving from '../../context/SaveContext';
import ComponentConfigurations from '../ComponentConfigurations/ComponentConfigurations';
import WatsonFlow from '../WatsonFlow/WatsonFlow';
import ConversationFlowBreadCrumbsWithFlowConfig from './ConversationFlowBreadCrumbsWithFlowConfig';

class ConversationFlow extends Component {
  constructor() {
    super();
    this.lastElementFlowId = 1;
    this.state = {
      flow: null,
      isValidFlow: true,
      mustUpdateBackendFlow: false,
      stackComponents: {},
      componentSelected: null,
      backupFlow: {},
      showComponentBoxButton: true,
      componentsToRemove: false,
      isLoading: false,
      showDialogNotificationMessage: null,
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.props.setBreadscrumbs(null);
    this.props.contextBots.deactivateBot();
    this.props.contextBots.setActivedBot(this.props.activeBotId);
    this.props.contextSave.resetSavingStatus();
  }

  shouldComponentUpdate(nextProp) {
    if (nextProp.contextSave.savingStatus && nextProp.contextSave.savingStatus.savingInWatson) {
      return false;
    }
    return true;
  }

  componentDidUpdate(prevProps) {
    /** Se o fluxo  do contexto não tiver carregado ou o bot selecionado for alterado
     * então requisita que o fluxo seja carregado */
    if (!this.props.contextBots.flow
      || prevProps.contextBots.activeBotId !== this.props.contextBots.activeBotId) {
      this.props.contextBots.setFlow();
      return null;
    }

    /** Se o fluxo do componente não tiver carregado
     *  ou se o fluxo for alterado
     *  então inicializa o fluxo */
    if (!this.state.flow || prevProps.contextBots.flow.name !== this.props.contextBots.flow.name) {
      this.initConversationFlow();
      return null;
    }

    const componentsInContextAmount = this.props.contextBots.flow.bots.length;
    const componentsInLocalAmount = Object.values(this.state.flow)
      .filter((c) => c.type === 'NodeFlow' && c.data.typeElement.id !== ComponentsType.INICIO.id)
      .length;

    /** Se o estado mustUpdateBackendFlow for true e o fluxo for válido,
     *  o backend é atualizado updateBackendFlow */
    if (this.state.mustUpdateBackendFlow && this.state.isValidFlow) {
      this.callUpdateBackend(componentsInLocalAmount, componentsInContextAmount);
      return;
    }

    const isUpdatedBackendFinished = (prevProps.contextSave.savingStatus.isSaving
      && !this.props.contextSave.savingStatus.isSaving);
    const isUpdateBackendFlowSuccessed = this.props.contextSave.savingStatus.isSuccessfulSave;

    // Se a atualização do backend acabou e falhou então reinicializa o fluxo
    if (isUpdatedBackendFinished && !isUpdateBackendFlowSuccessed) {
      this.initConversationFlow();
      return;
    }

    /** Se a atualização acabou e a quantidade de componentes locais e no contexto são as mesmas.
     *  siginifica que o fluxo do estado do componente já foi sincronizado com o fluxo do contexto.
     *  Mas ainda é necessário ajustar os identifcadores e outros atributos vindos do
     *  fluxo do componente, por que sempre que o contexto é atualizado esse atributos
     *  são alterados pelo backend */
    if (isUpdatedBackendFinished && componentsInLocalAmount === componentsInContextAmount) {
      this.adjustComponentsAfterBackendUpdate();
    }
  }

  /** Ajusta os identifcadores e outros atributos vindos do fluxo do componente,
   * por que sempre que o contexto é atualizado esse atributos
   * são alterados pelo backend */
  adjustComponentsAfterBackendUpdate = () => {
    const { flow } = this.state;
    Object.keys(flow).forEach((localId) => {
      const component = flow[localId];
      if (component.type === 'NodeFlow'
        && component.data.typeElement.id !== ComponentsType.INICIO.id) {
        const { order } = component;
        const bot = this.props.contextBots.flow.bots.find((b) => b.order === order);

        const contextId = bot.id;

        // Se o id local for diferente do id do contexto então é realizada atualização
        if (localId !== contextId) {
          flow[contextId] = { ...component };
          flow[contextId].id = contextId;
          flow[contextId].data.id = contextId;
          flow[contextId].data.label = bot.name;
          flow[contextId].data.labelFromBackend = bot.name;
          flow[contextId].data.environmentConfigurationId = bot.environmentConfigurations.find((e) => e.environment.type.mnemonic === 'd').id;

          // Ajusta edges dos componentes que foram sincronizados
          Object.keys(flow).forEach((keyEdge) => {
            if (keyEdge.startsWith('edge')) {
              const edge = flow[keyEdge];
              if (edge.target === localId) {
                flow[keyEdge].target = contextId;
              } else if (edge.source === localId) {
                flow[keyEdge].source = contextId;
              }
            }
          });

          // O componente com localId que foi atulizado é removido do fluxo
          delete flow[localId];
        }

        // Atualiza o componente selecionado se ele existir
        if (this.state.componentSelected && this.state.componentSelected.id === localId) {
          this.setState({ componentSelected: { ...flow[bot.id].data } });
        }
      }
    });
    this.setState({ flow });
  }

  /** Chama a atualização do fluxo no contexto.
   * É realizada uma requisição no server para atualizar o backend
   * e a resposta é usada para atualizar o contexto
   * @param {*} componentsInLocalAmount
   * @param {*} componentsInContextAmoun  */
  callUpdateBackend = (componentsInLocalAmount, componentsInContextAmount) => {
    let components = [...this.props.contextBots.flow.bots];
    if (componentsInLocalAmount >= componentsInContextAmount) {
      // Adicionar componentes
      components = components.map((c) => {
        const ret = { ...c, order: this.state.flow[c.id].order };
        if (c.id.startsWith('node')) { delete ret.id; }
        return ret;
      });
    } else {
      // Remover ou atualizar componentes
      components = components.filter((c) => Object.keys(this.state.flow).includes(c.id));
    }

    const flow = { ...this.props.contextBots.flow, bots: [...components] };
    const successUpdatedFlow = () => this.setState({ isLoading: false, componentSelected: null });

    this.props.contextBots.updateBackendFlow(flow, successUpdatedFlow);
    this.setState({ mustUpdateBackendFlow: false });
  }

  /**
   * Organiza as posições dos elementos do fluxo, de forma sequêncial.
   * Para isso, utiliza o atributo next adicionado em
   * cada elemento do fluxo adicionado no metodo  setNextOfEachComponent
   * @param {*} flow
   * @returns fluxo com elementos atualizados com posições sequenciais
   */
  setFlowElementsPosition = (flow) => {
    let yPosition = 0;
    let xPosition = 20;
    let node = Object.values(flow).filter((e) => e.firstNode)[0];
    node.position = { x: xPosition, y: yPosition };
    while (node.next) {
      node = flow[node.next];
      yPosition += 110;
      xPosition = 150;
      node.position = { x: xPosition, y: yPosition };
    }
    node.lastNode = true;
    return flow;
  }

  /** Retorna ações referenciadas por manipuladores que são injetados
   *  no nós na renderização que é realizada no componente NodeFlow  */
  getActionsNode = () => ({
    addNodeFlow: this.addNodeFlowHandler,
    editComponent: this.editNodeFlowHandler,
    createNode,
    createEdge,
  });

  /** Cria o primeiro nó do fluxo que representa o início da conversação */
  createFirstNode = (actionsNode) => {
    const node = createNode(ComponentsType.INICIO, 0, 0);
    node.firstNode = true;
    node.data = {
      ...node.data,
      ...actionsNode,
      label: '',
      notAllowedEngineAfter: true,
    };
    return node;
  }

  /** Cria os nós do fluxo */
  createNodes = (components) => {
    let flow = {};

    let sourceId = null;
    const actionsNode = this.getActionsNode();

    let node = this.createFirstNode(actionsNode);
    sourceId = node.id;
    flow[node.id] = node;

    // Cria nós para bots do fluxo carregado no contexto enviados no parametro components
    components.forEach((component) => {
      const componentType = findComponentBy('title', component.engineRelease.engine.name);
      node = createNode(componentType, 0, 0);
      node.data = { ...node.data, ...actionsNode };

      node.id = component.id;
      node.order = component.order;
      node.data.order = component.order;
      node.data.flowLength = components.length;
      node.data.id = component.id;
      node.data.isValid = true;
      node.data.label = component.name;
      node.data.labelFromBackend = component.name;
      node.data.environmentConfigurationId = component.environmentConfigurations.find((e) => e.environment.type.mnemonic === 'd').id;
      node.data.parameters = component.environmentConfigurations.find((e) => e.environment.type.mnemonic === 'd').parameterValues;
      node.data.notAllowedEngineAfter = component.notAllowedEngineAfter;
      node.data.notAllowedChangeTitle = component.notAllowedChangeTitle;
      node.data.notAllowedDelete = component.notAllowedDelete;
      node.data.notAllowedChangeLocation = component.notAllowedChangeLocation;

      // Adicion nó no fluxo
      flow[node.id] = node;
      // Cria vertice entre o nó anterior e nó corrente no laço
      const edge = createEdge(sourceId, component.id, this.lastElementFlowId++);
      if (flow[sourceId].data.typeElement.id === ComponentsType.INICIO.id) {
        edge.targetHandle = 'targetHandle';
      }
      // Defini atributo next do nó anterior como o nó atual
      flow[sourceId].next = component.id;
      node.previous = sourceId;

      // Adiciona vertice no fluxo
      flow[edge.id] = edge;
      sourceId = component.id;
    });

    flow = this.setFlowElementsPosition(flow);

    return flow;
  }

  /** Inicializa o fluxo de conversação.
   *
   *  Defini o breadcrumbs com o nome do fluxo.
   *  Cria a representação do fluxo que será enviado para o canvasFlow
   */
  initConversationFlow = () => {
    this.props.setBreadscrumbs(
      <ConversationFlowBreadCrumbsWithFlowConfig
        contextBots={this.props.contextBots}
      />,
    );

    const components = JSON.parse(JSON.stringify(this.props.contextBots.flow.bots));

    const flow = this.createNodes(components);
    this.setState({
      stackComponents: this.props.contextBots.flow.stack.supportedEngineReleases,
      flow,
      componentSelected: null,
      isLoading: false,
    });
  }

  /** Valida se o novo nó pode ser adicionado no fluxo.
   *
   * Configura o estado showDialogNotificationMessage para mostrar uma
   * mensagem de notificação que explique a não realização da operação,
   * se sua realização não for possivel
   *
   * Nós não podem ser adicionado se o fluxo estiver invalido.
   * Nó do tipo Watson Assistant não podem ser adicionados.
   */
  addNodeFlowValidator = (node) => {
    if (!this.state.isValidFlow) {
      this.setState({
        showDialogNotificationMessage: {
          title: 'Componente não pode ser adicionado no fluxo inválido',
          message: 'Revise os componentes inválidos do fluxo antes de adicionar novo componente',
        },
      });
      return false;
    }

    if (node.data.typeElement.id === ComponentsType.WATSON.id) {
      this.setState({
        showDialogNotificationMessage: {
          title: 'Componente Watson Assistant não pode ser adicionado',
          message: 'Solicite ao administrador do bot para para adicionar um novo componente Watson Assistant',
        },
      });

      return false;
    }

    return true;
  }

  /** Manipulador da ação de adição de nó no fluxo.
   *
   * Se o nó a ser adicionado não for válido, não prossegue com a operação
   * Adiciona o nó no fluxo
   * Defini as posições dos nós no fluxo para mante-lo como uma sequência
   */
  addNodeFlowHandler = (node, edge) => {
    if (!this.addNodeFlowValidator(node)) return null;

    const newNode = node;
    const actionsNode = this.getActionsNode();
    newNode.data = { ...newNode.data, ...actionsNode };

    let flow = { ...this.state.flow };
    flow = addNodeFlow(flow, newNode, edge);
    flow = this.setFlowElementsPosition(flow);
    this.setState({
      flow,
      componentSelected: newNode.data,
      showMessageNotificationInvalidComponent: false,
    });
  };

  /** Manipulador da ação de edição de nó no fluxo */
  editNodeFlowHandler = (idComponent) => {
    const { flow } = this.state;
    const componentSelected = {
      ...flow[idComponent].data,
      previous: flow[idComponent].previous,
    };
    this.setState({ componentSelected, showMessageNotificationInvalidComponent: false });
  };

  /** Remove nó do fluxo.
   *
   * Antes do nó ser removido é necessário confirmação.
   * Por isso, o estado isConfirmationNeeded se torna true, para que na próxima renderização
   * a caixa de dialogo solicitando a confirmação seja apresentada.
   *
   * Se o no a ser removido for do tipo Watson, o estado showDialogNotificationMessage
   * é configurado para apresentar uma notificação de proibição da remoção do nó
   */
  removeNodeFlow = (elements) => {
    const _elements = elements;
    let isConfirmationNeeded = false;
    let isWatsonDeleting = false;

    let label = '';
    _elements.forEach((element, index) => {
      if (element.type === 'NodeFlow') {
        label = this.state.flow[element.id].data.label;
        const { typeElement } = this.state.flow[element.id].data;
        isWatsonDeleting = typeElement.id === ComponentsType.WATSON.id;
        _elements[index].label = label;
        isConfirmationNeeded = true;
      }
    });

    if (isWatsonDeleting) {
      this.setState({
        showDialogNotificationMessage: {
          title: 'Componente Watson Assistant não pode ser removido',
          message: `Solicite ao administrador do bot a remoção do componente ${label}`,
        },
      });
      return;
    }

    if (isConfirmationNeeded) {
      this.setState({ componentsToRemove: _elements });
    } else {
      return null;
    }
  };

  /**
   * Remove elementos do fluxo
   *
   * Depois que elementos são removidos do fluxo, o estado mustUpdateBackendFlow é marcado como true
   * para que no próximo didUpdate, os componentes também sejam removidos no backend
   * @param {*} elements elementos que devem ser removidos
   */
  confirmRemoveElementFlow = (elements) => {
    let { flow } = this.state;
    elements.forEach((e) => {
      Object.keys(flow).forEach((key) => {
        if (flow[key].next && flow[key].next === e.id) {
          flow[key].next = flow[e.id].next;
          if (flow[key].next) {
            const newEdge = createEdge(key, flow[e.id].next, this.lastElementFlowId++);
            if (flow[key].data.typeElement.id === ComponentsType.INICIO.id) {
              newEdge.targetHandle = 'targetHandle';
            }
            flow[newEdge.id] = newEdge;
          }
        }
      });

      delete flow[e.id];
    });
    flow = this.setFlowElementsPosition(flow);
    this.setState({
      flow,
      mustUpdateBackendFlow: true,
      isLoading: true,
    });
  }

  /** Manipulador da ação de alteração da localização dos componentes no fluxo
   *
   * Identifica o no que tem sua localização alterada.
   * Adiciona ele na posição referente a nova localização.
   * Atualiza o parametro order de todos os nós para manter a ordem sequencial do fluxo
   * Atualiza o fluxo no contexto
   *
   * O Backend não é atualizado nesse manipulador.
   * Isso acontecerá quando o editor do componente for fechado e o updateNodeHandle for executado
   */
  changeNodeLocalizationHandle = (idComponent, newOrder) => {
    let allBots = this.props.contextBots.flow.bots;
    const selectedBot = allBots.find((b) => b.id === idComponent);
    const allOthersBots = allBots.filter((b) => b.id !== idComponent);
    const { componentSelected } = this.state;

    if (allBots[newOrder].notAllowedChangeLocation) return null;
    componentSelected.previous = allBots[newOrder].id;

    selectedBot.hasOrderAltered = true;
    allOthersBots.splice(newOrder, 0, selectedBot);

    allBots = allOthersBots.map((b, idx) => ({ ...b, order: idx }));

    this.props.contextBots.updateContextFlow({
      ...this.props.contextBots.flow,
      bots: [...allBots],
    });

    const flow = this.createNodes(allBots);

    this.setState({
      flow,
      mustUpdateBackendFlow: false,
      componentSelected,
    });
  }

  getAttributeInComponentToCompare = (component) => ({
    name: component.name,
    order: component.order,
    hasOrderAltered: component.hasOrderAltered,
    knowledgeBases: component.knowledgeBases,
    parameterValues: component.environmentConfigurations.find((e) => e.environment.type.mnemonic === 'd').parameterValues.map((a) => a.value),
  })

  /**
   * Atualiza o nó com idComponent no fluxo usando componentUpdated
   * @param {*} component
   * @param {*} idComponent
   */
  updateNodeFlow = (component, idComponent) => {
    const componentUpdated = component;

    this.setState((prevState) => {
      const { flow } = prevState;
      if (flow[idComponent]) {
        flow[idComponent].data = {
          ...flow[idComponent],
          ...componentUpdated,
        };
      }

      const { typeElement } = componentUpdated;
      const componentSelected = (typeElement.id === ComponentsType.WATSON.id)
        ? componentUpdated : null;

      return {
        ...prevState,
        flow,
        componentSelected,
      };
    });
  }

  createNewComponentInContext = (components, componentUpdated) => {   
    components.push({
      id: componentUpdated.id,
      name: componentUpdated.label,
      engineRelease: { id: componentUpdated.engineRelease },
      environmentConfigurations: [{
        environment: componentUpdated.environmentConfigurations,
        parameterValues: componentUpdated.parameters,
      }],
      order: null,
    });
  }

  /** Se não existir mudanças entre o componente que deveria ser alterado e
    * sua versão atual no contexto e não aconteceu alteração da ordem desse componente,
    * então o componente não será atualizado  */
  shouldComponentChangedInContex = (indexUpdatedComponent, components) => {
    const updatedComponentInContext = this.getAttributeInComponentToCompare(
      this.props.contextBots.flow.bots[indexUpdatedComponent],
    );

    const updatedComponent = this.getAttributeInComponentToCompare(
      components[indexUpdatedComponent],
    );

    const theresIsNoChanges = JSON.stringify(updatedComponentInContext) === JSON.stringify(updatedComponent);
    
    if (theresIsNoChanges && !updatedComponent.hasOrderAltered) {
      return false;
    }

    return true;
  }

  /**
   * Atualiza o componente no fluxo carregado no contexto
   *
   * @param {*} componentUpdated
   * @param {*} idComponent
   * @returns true se o componente for atualizado, false caso contrario
   */
  updateComponentInContex = (componentUpdated, idComponent) => {
    let indexUpdatedComponent = null;
    let componentUpdateIsNew = true;
    const components = JSON.parse(JSON.stringify(this.props.contextBots.flow.bots));

    components.forEach((component, index) => {
      if (component.id === idComponent) {
        componentUpdateIsNew = false;
        const envConfIndex = components[index].environmentConfigurations.findIndex((e) => e.environment.type.mnemonic === 'd');

        components[index].environmentConfigurations[envConfIndex] = {
          ...components[index].environmentConfigurations[envConfIndex],
          parameterValues: componentUpdated.parameters,
        };

        components[index].name = componentUpdated.label;
        components[index].knowledgeBases = componentUpdated.knowledgeBases;
        
        indexUpdatedComponent = index;
      }
    });

    if (componentUpdateIsNew) {
      this.createNewComponentInContext(components, componentUpdated);
    } else if (!this.shouldComponentChangedInContex(indexUpdatedComponent, components)) {
      return false;
    }

    /** Se o componente for novo, o contexto so será atualizado se o fluxo local estiver válido */
    if (!componentUpdateIsNew || (componentUpdateIsNew && this.state.isValidFlow)) {
      this.props.contextBots.updateContextFlow({
        ...this.props.contextBots.flow,
        bots: [...components],
      });
    }

    return true;
  }

  /**
   * Manipulador da ação de alteração do componente.
   *
   * Chamado quando o editor de configurações do componente é fechado.
   * Atualiza a representação do fluxo no componente.
   * Atualiza o fluxo no contexto.
   * Se o fluxo estiver valido alterado o mustUpdateBackendFlow para que
   * a atualização do backend seja chamada na próxima rendenrização
   * @param {*} idComponent
   * @param {*} componentUpdated
   */
  updateNodeHandle = (idComponent, componentUpdated) => {
    this.updateNodeFlow(componentUpdated, idComponent);
    const updatedInContex = this.updateComponentInContex(componentUpdated, idComponent);

    if (!this.state.isValidFlow) {
      this.setState({ showMessageNotificationInvalidComponent: true });
      return;
    }
    if (!updatedInContex) return;

    this.setState({ mustUpdateBackendFlow: true });
  };

  /** Retorna caixa de dialogo para confirmação de remoção do componente   */
  deletingComponentDialogConfirmation = () => {
    let componentName = this.state.componentsToRemove
      .filter((el) => el.label)
      .map((el) => el.label).join(', ');

    componentName = (
      <strong>
        {` ${componentName} `}
      </strong>
    );
    const content = (
      <>
        Deseja prossseguir com a exclusão do componente
        {componentName}
        ?
      </>
    );
    return (
      <DeleteConfirmation
        title="Confirmar exclusão de componente"
        content={content}
        confirmationClick={() => {
          this.confirmRemoveElementFlow(this.state.componentsToRemove);
          this.setState({ componentsToRemove: null });
        }}
        cancelationClick={() => this.setState({ componentsToRemove: null })}
      />
    );
  }

  /** Mostra caixa de dialogo com uma notificação
   *
   * Para preencher a notificação, o estado showDialogNotificationMessage precisa ser atualizado com
   * objeto contendo title e message
   */
  showDialogNotificationGeneric = () => {
    if (this.state.showDialogNotificationMessage) {
      return (
        <DialogNotification
          okAction={() => this.setState({ showDialogNotificationMessage: null })}
          title={this.state.showDialogNotificationMessage.title}
          content={<p>{this.state.showDialogNotificationMessage.message}</p>}
        />
      );
    }

    return null;
  }

  /** Mostra mensagem de notificação que desaperece em 3 segundos,
   * caso o estado showMessageNotificationInvalidComponent seja verdadeiro */
  showMessageNotificationInvalidComponent = () => {
    if (this.state.showMessageNotificationInvalidComponent) {
      setTimeout(() => {
        this.setState({ showMessageNotificationInvalidComponent: false });
      }, 3000);
      return (
        <MessageNotification
          type="danger"
          content={(
            <>
              <strong>O fluxo não foi salvo. </strong>
              <span>Revise os componentes invalidos</span>
            </>
          )}
        />
      );
    }
    return null;
  }

  setOrderOfComponents = (firstComponent, flow) => {
    let first = firstComponent;
    const changedFlow = flow;
    let order = 0;
    while (first.next) {
      changedFlow[first.next].order = order;
      first = flow[first.next];
      order += 1;
    }

    return changedFlow;
  }

  /** Adiciona o atributo next em cada componente.
   * Esse atributo e usado para definir a ordem de cada componente */
  setNextOfEachComponent = (flow) => {
    const changedFlow = { ...flow };
    Object.keys(changedFlow).forEach((key) => {
      if (changedFlow[key].id.startsWith('edge')) {
        const { source } = changedFlow[key];
        const { target } = changedFlow[key];
        changedFlow[source].next = target;
        changedFlow[target].previous = source;
      }
    });
    return changedFlow;
  }

  /** Verifica se todos os componentes do fluxo são validos.
   * Se algum componente não for valido, altera o estado isValidFlow para
   * false e showMessageNotificationInvalidComponent para true
   *
   * Adiciona o atriuto order nos componentes.
   * Esse atributo e usado para ordernar os componentes
   * quando o fluxo for enviado para o backend
   */
  validateFlow = (_flow) => {
    const flow = _flow;
    let isValidFlow = true;
    let firstComponent = null;

    Object.keys(flow).forEach((key) => {
      if (flow[key].type === 'NodeFlow') {
        const { data } = flow[key];
        const errorsList = [];

        if (data.typeElement === null) {
          console.log(data.typeElement.id);
        }

        if (data.typeElement.id !== ComponentsType.INICIO.id
          && !data.isValid) {
          errorsList.push('As informações do componente precisam ser revisadas');
        }

        if (data.typeElement.id === ComponentsType.INICIO.id) {
          firstComponent = flow[key];
        }

        flow[key].data = {
          ...data,
          errorsList,
          isValidFlow: this.state.isValidFlow,
        };
        isValidFlow = isValidFlow && errorsList.length === 0;
      }
    });

    if (isValidFlow !== this.state.isValidFlow) {
      this.setOrderOfComponents(firstComponent, flow);
      this.setState({ isValidFlow });
    }

    return flow;
  }

  /** Manipulador de click para botão que remove o componente
   * na caixa de configurações do componente selecionado  */
  removeComponentHandler = (elementToRemove) => {
    const elementToRemoveId = elementToRemove.id;
    const elementsToRemove = Object.values(this.state.flow)
      .filter((e) => (
        e.id === elementToRemoveId
        || (e.source && e.source === elementToRemoveId)
        || (e.target && e.target === elementToRemoveId)
      ));
    this.removeNodeFlow(elementsToRemove);
  }

  /** Recupera todos os nomes de componentes */
  getComponentsListNames = () => Object.values(this.state.flow).map((c) => {
    if (c.data && c.data.label !== '' && c.id !== this.state.componentSelected.id) return c.data.label;
  }).filter((n) => n);

  /** Mostra a caixa de configurações dos
   * componentes se existir algum componente selecionado   */
  showComponentConfiguration = () => {
    /** Se não existir componente selecionado, ou ele já tiver sido removido,
     * a caixa de configuração é renderizada vazia represetando o fechamento da caixa */
    if (!this.state.componentSelected || !this.state.flow[this.state.componentSelected.id]) {
      return <ConfigurationsBox />;
    }

    const componentSelected = { ...this.state.componentSelected };
    componentSelected.order = this.state.flow[this.state.componentSelected.id].order;

    return (
      <ConfigurationsBox>
        <ComponentConfigurations
          contextFlow={this.props.contextBots.flow}
          flow={this.state.flow}
          isValidFlow={this.state.isValidFlow}
          componentSelected={componentSelected}
          componentsListNames={this.getComponentsListNames()}
          updateNode={this.updateNodeHandle}
          changeNodeLocalizationHandler={this.changeNodeLocalizationHandle}
          removeElementFlow={this.removeComponentHandler}
        />
      </ConfigurationsBox>
    );
  }

  /** Mostra mensagem de carregamento, caso estado isLoading seja verdadeiro */
  showLoading = () => (this.state.isLoading ? <Loading message="Aguarde" /> : null)

  /** Mostra caixa de dialogo para confirmação de remorção
   *  de componente se existir algum componente para ser removido no estado componentsToRemove */
  showDeletingComponentConfirmation = () => (
    this.state.componentsToRemove ? this.deletingComponentDialogConfirmation() : null);

  /** Realizar alterações no estado do componente
   *  e do contexto para retornar ao fluxo principal do bot */
  backToMainFlow = () => {
    this.props.contextSave.resetSavingStatus();
    this.initConversationFlow();
    this.setState({ componentSelected: null });
  }

  /** Se o componente selecionado for do tipo Watson é retornado
   * o fluxo do watson no lugar do fluxo principal */
  returnWatsonFlow = () => {
    const renderBreadcrumbs = () => this.props.setBreadscrumbs(
      <Breadcrumbs>
        <button
          type="button"
          onClick={this.backToMainFlow}
          disabled={this.props.contextSave.savingStatus.isSaving}
        >
          {this.props.contextBots.flow.name}
        </button>
        <span>{this.state.componentSelected.label}</span>
      </Breadcrumbs>,
    );

    return (
      <WatsonFlow
        componentsListNames={this.getComponentsListNames()}
        renderBreadcrumbs={renderBreadcrumbs}
        updateWatsonComponent={this.updateNodeHandle}
        componentSelected={this.state.componentSelected}
        backToMainFlow={this.backToMainFlow}
      />
    );
  }

  isComponentSelectedAWatson = () => this.state.componentSelected
    && this.state.componentSelected.typeElement.id === ComponentsType.WATSON.id

  /**
   * Se não existir botId redireciona para home, onde o bot deve ser escolhido
   *
   * Se o flow do contextBot ainda não tiver carregado
   * retorna null e espera para aguardar esse carregamento
   *
   * Se algum componente Watson  for selecionado é retornado do watson
   * @returns
   */
  render() {
    if (!this.props.activeBotId) return <Redirect to="/" />;
    if (this.isComponentSelectedAWatson()) return this.returnWatsonFlow();

    let flow = this.setNextOfEachComponent(this.state.flow);
    flow = this.validateFlow(flow);

    /**
     * O fluxo sera exibido
     * Alguns componentes auxiliares também podem ser exibidos
    */
    return (
      <>
        {/* Componentes auxiliares */}
        {this.showLoading()}
        {this.showMessageNotificationInvalidComponent()}
        {this.showDialogNotificationGeneric()}
        {this.showDeletingComponentConfirmation()}

        <div style={{ position: 'relative', height: '100%' }}>
          <CanvasFlow
            flow={flow}
            addNodeFlow={this.addNodeFlowHandler}
            editComponent={this.editNodeFlowHandler}
            removeElementFlow={this.removeNodeFlow}
          />
          {this.showComponentConfiguration()}
        </div>
      </>
    );
  }
}

class ConversationFlowWraper extends Component {
  render() {
    return (
      <ContextBots.Consumer>
        {(contextBot) => (
          <ContextSaving.Consumer>
            {(context) => (
              <ConversationFlow
                contextSave={context}
                contextBots={contextBot}
                {...this.props}
              />
            )}
          </ContextSaving.Consumer>
        )}
      </ContextBots.Consumer>
    );
  }
}

export default withRouter(ConversationFlowWraper);
